<template>
  <div>
    <p v-if="displayType === 'long'">
      Equity Sector Diversification includes directly held securities as well as equities held through funds.
      <template v-if="portfolio && benchmark">
        This breakdown applies to {{ portfolio.sector_market_cap_asset_class_breakdown?.sector_breakdown_coverage?.toLocaleString('en-US', { style: 'percent' }) }} of {{ portfolio.name }} and {{ benchmark.sector_market_cap_asset_class_breakdown?.sector_breakdown_coverage?.toLocaleString('en-US', { style: 'percent' }) }} of {{ benchmarkName }}.
      </template>
      <template v-else-if="portfolio">
        This breakdown applies to {{ portfolio.sector_market_cap_asset_class_breakdown?.sector_breakdown_coverage?.toLocaleString('en-US', { style: 'percent' }) }} of {{ portfolio.name }}.
      </template>
      <template v-else-if="benchmark">
        This breakdown applies to {{ benchmark.sector_market_cap_asset_class_breakdown?.sector_breakdown_coverage?.toLocaleString('en-US', { style: 'percent' }) }} of {{ benchmarkName }}.
      </template>
      Sector data from funds uses holdings as of data of most recent NPORT SEC filing.
    </p>

    <p v-else>
      This Equity Sector Diversification chart applies to directly held securities as well as equities held through funds.
      <template v-if="portfolio && benchmark">
        This breakdown applies to {{ portfolio.sector_market_cap_asset_class_breakdown?.sector_breakdown_coverage?.toLocaleString('en-US', { style: 'percent' }) }} of {{ portfolio.name }} and {{ benchmark.sector_market_cap_asset_class_breakdown?.sector_breakdown_coverage?.toLocaleString('en-US', { style: 'percent' }) }} of {{ benchmarkName }}.
      </template>
      <template v-else-if="portfolio">
        This breakdown applies to {{ portfolio.sector_market_cap_asset_class_breakdown?.sector_breakdown_coverage?.toLocaleString('en-US', { style: 'percent' }) }} of {{ portfolio.name }}.
      </template>
      <template v-else-if="benchmark">
        This breakdown applies to {{ benchmark.sector_market_cap_asset_class_breakdown?.sector_breakdown_coverage?.toLocaleString('en-US', { style: 'percent' }) }} of {{ benchmarkName }}.
      </template>
    </p>
  </div>
</template>


<script>
export default {
  name: 'SectorMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
  computed: {
    benchmarkName() {
      return this.benchmark?.name || 'Benchmark';
    },
  },
};
</script>
